<template>
  <div
    class="fshr-rating"
    :class="
      isSelectable ? 'fshr-rating--isSelectable' : 'fshr-rating--isDefault'
    "
  >
    <div class="fshr-rating-inner" v-if="type === 'stars'">
      <span
        v-for="index in 5"
        :key="index"
        class="fshr-rating__item"
        v-tooltip="tooltipDescription(index)"
        :class="{
          'fshr-rating__item--active':
            stars >= index ||
            (!isSelectable &&
              stars % 1 !== 0 &&
              stars >= index - 1 &&
              stars < index),
          'icon-star':
            stars % 1 === 0 || (stars % 1 !== 0 && stars >= index - 1),
          'icon-star-half':
            !isSelectable &&
            stars % 1 !== 0 &&
            stars >= index - 1 &&
            stars < index,
        }"
        :tabindex="isSelectable && 0"
        @click="onClick($event, index)"
      ></span>
    </div>
    <div class="fshr-rating-inner" v-else>
      <span
        v-for="minleafs in min_leafs"
        :key="minleafs"
        class="fshr-rating__item icon-leaf fshr-rating__item--active"
      ></span>
      <span v-if="min_leafs !== max_leafs" class="fshr-separator">/</span>
      <span
        v-if="min_leafs !== max_leafs"
        v-for="maxleafs in max_leafs"
        :key="maxleafs"
        class="fshr-rating__item fshr-rating__item--active icon-leaf"
      ></span>
    </div>
  </div>
</template>

<script>
/**
 * @emits onChange when rating changes to new star value
 */
export default {
  name: "star-rating",
  props: {
    /**
     * define how many stars will be filled
     * If not selectable: may have half-points values: .5, 1.5, 2.5, 3.5, 4.5
     * For selectable variant - only Integer should be possible
     */
    rating: {
      type: Number,
      required: false,
      default: 0,
    },
    /**
     * can user change a stars (if not then is readonly)
     * only Integer ratings should be passed to choose from
     */
    isSelectable: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String,
      required: false,
      default: "stars",
    },
    translations: {
      type: Object,
      required: false,
      default: function () {
        return {
          minimalniKategorie: "Minimální kategorie",
        };
      },
    },
  },

  data() {
    return {
      stars: this.rating,
    };
  },

  methods: {
    onClick(e, index) {
      e.preventDefault();
      e.stopPropagation();

      if (this.isSelectable) {
        this.stars = index;

        // only omit changes when value is different
        if (this.stars !== this.rating) {
          this.$emit("onChange", this.stars);
        }
      }
    },
    tooltipDescription: function (stars) {
      if (this.isSelectable) {
        return this.getBasicTooltip(
          this.getTranslation("minimalniKategorie") + " " + stars + "*"
        );
      }
    },
  },
  computed: {
    min_leafs: function () {
      return Math.floor(this.stars);
    },
    max_leafs: function () {
      return Math.ceil(this.stars);
    },
  },
  watch: {
    rating(value) {
      this.stars = value;
    },
  },
};
</script>
